"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurgeryEventType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var SurgeryEventType_Factory = /** @class */ (function () {
    function SurgeryEventType_Factory() {
    }
    SurgeryEventType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    SurgeryEventType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    return SurgeryEventType_Factory;
}());
exports.SurgeryEventType_Factory = SurgeryEventType_Factory;
